var brandInfoAll={
  bannerInfo:{
    bannerNmae:"智同科技",
    createTime:"2015年",
    area:"中国 北京",
    honor:[
      '国家高新技术企业称号',
      '中关村高新技术企业',
      '北京市专精特新“小巨人”企业',
      '恰佩克新锐奖',
      '2021年高工金球奖年度创新产品奖'
    ]
  },
  subsidiary:[
    {
      name:"北京",
      langname:"北京（总公司）",
      address:"北京市北京经济技术开发区经海三路29号1幢D座D101",
      corporateName:"北京智同精密传动科技有限责任公司"
    },
    {
      name:"北京",
      langname:"北京（技术研究院）",
      address:"北京市通州区经海五路1号院北工大科技园28号及29号楼11层",
      corporateName:"北京智同工大智能传动技术研究院"
    },
    {
      name:"河北",
      langname:"河北（子公司）",
      address:"河北省石家庄市高新区太行大街759号连铸连轧车间",
      corporateName:"河北智昆精密传动科技有限公司"
    },
    {
      name:"广州",
      langname:"广州（办事处）",
      address:"广州市黄埔区科学大道118.120号611房",
      corporateName:"北京智同精密传动科技有限责任公司"
    },
    {
      name:"苏州",
      langname:"苏州（办事处）",
      address:"苏州工业园区苏虹东路177号方正智谷1号楼908室",
      corporateName:"北京智同精密传动科技有限责任公司"
    },
    {
      name:"深圳",
      langname:"深圳（办事处）",
      address:"深圳市福田区竹子林求是大厦西座1706室",
      corporateName:"北京智同精密传动科技有限责任公司"
    },
    {
      name:"长沙",
      langname:"长沙（办事处）",
      address:"长沙市望城区金桥国际未来城1栋23楼2318室",
      corporateName:"北京智同精密传动科技有限责任公司（中南办事处）"
    },
  ],
  advantages:{
    advantages:"/static/brand/zhitong/youshi/left.png",
    advantagesTitle:"/static/brand/zhitong/youshi/top.png",
    info:"产品在效率、空程、温升、噪音等指标上达到了国外主流产品水平。精度保持性、传动精度和刚性等3项指标略优，疲劳寿命指标大幅优于国外主流产品。",
    type:1
  },
  brandAdvantage:{
    titleImg:"/static/brand/zhitong/tedian/left.png",
    oneTitle:"张跃明",
    twoTitle:"首席科学家",
    list:[
      "哈尔滨工业大学硕士，清华大学博士，北京工业大学博士后，北京工业大学教授。",
      "中国机器人减速器知名专家，中国机器人产业联盟标准组成员，智同科技 - 北京工业大学精密传动技术研究院院长。",
      "一直致力于齿轮啮合理论、机构学与机构动力学、数字化设计与制造等方面的教学与科研工作。",
      "曾荣获：国家科技重大专项4项、国家863项目1项、北京市科委重点支持项目4项、北京市教委项目2项，以及11项纵向科研项目支持。"
    ]
  },
  certify:[
     
  ],

  otherProductsAdvantages:{
    productsTitle:"/static/brand/zhitong/tedian/title.png",
    aboutTitleWidth:"849px",
    textList:[
      '产品在效率、空程、温升、噪音等指标上达到了国外主流产品水平。',
      '精度保持性、传动精度和刚性等3项指标略优，疲劳寿命指标大幅优于国外主流产品。'
    ],
    textImg:"/static/brand/zhitong/youshi/product.png",
    height:"272px",
    list:[
      {
        titleImg:"/static/brand/zhitong/tedian/01.png",
        infoList:[
          '自主研制专用批量检测量具、测试仪器及试验台，实现批量快速检测，数据自动录入数据库。',
        ],
      },
      {
        titleImg:"/static/brand/zhitong/tedian/02.png",
        infoList:[
          '自主研发的加工工艺和高精度、高效率装夹工装，保证产品高精度、高稳定性和高效率。',
        ],
      },
      {
        titleImg:"/static/brand/zhitong/tedian/03.png",
        infoList:[
          '拥有世界顶尖水平的高精度数控生产装备，量身定制，保证了高精度批量加工的稳定性及效率。',
        ],
      },
      {
        titleImg:"/static/brand/zhitong/tedian/04.png",
        infoList:[
          '独有的齿形设计及修形技术，强大的技术支持，使之能批量生产出受力合理、自适应制造误差、抗磨损能力强、传动平稳、噪音低的核心零部件。',
        ],
      },
      {
        titleImg:"/static/brand/zhitong/tedian/05.png",
        infoList:[
          '自主研发的装配工具、公差分配方法，提高了批量装配工作效率和精度。',
        ],
      },
      {
        titleImg:"/static/brand/zhitong/tedian/06.png",
        infoList:[
          '合作研发了专用热处理设备，保证了批量生产零部件基体性能的优质、一致。通过热处理的精准控制保证减速器质量稳定。',
        ],
      },
      {
        titleImg:"/static/brand/zhitong/tedian/07.png",
        infoList:[
          '专业的试验检测平台（对标国评中心），可对减速机的整体性能进行评测，出具检测报告。',
        ],
      },
    ]
  },
  pindustry:{
      industryTitleImg:"/static/brand/zhitong/hangye/industryTitleImg.png",
      list:[
        {
          bjimg:"/static/brand/zhitong/hangye/1.png",
          title:"机械手",
        },
        {
          bjimg:"/static/brand/zhitong/hangye/2.png",
          title:"并联机械手",
        },
        {
          bjimg:"/static/brand/zhitong/hangye/3.png",
          title:"自动化生产线",
        },
        {
          bjimg:"/static/brand/zhitong/hangye/4.png",
          title:"风车",
        },
        {
          bjimg:"/static/brand/zhitong/hangye/5.png",
          title:"机床行业",
        },
        {
          bjimg:"/static/brand/zhitong/hangye/6.png",
          title:"工程机械",
        },
        {
          bjimg:"/static/brand/zhitong/hangye/7.png",
          title:"自动门",
        },
        {
          bjimg:"/static/brand/zhitong/hangye/8.png",
          title:"飞机",
        },
        {
          bjimg:"/static/brand/zhitong/hangye/9.png",
          title:"列车",
        },
        {
          bjimg:"/static/brand/zhitong/hangye/10.png",
          title:"邮轮",
        }
      ]    
    },
  bigimg:"/static/brand/zhitong/bigimg/big.png",
  
  aboutus:
  {
        info:"北京智同科技成立于2015年，位于北京经济技术开发区，是国家高新技术企业。智同科技自主、正向研发的工业机器人用高精密摆线减速机，广泛应用于各类工业机器人、精密机床、工程装备等领域。智同科技致力于面向全球机器人及其他制造企业提供标准化减速机产品，并提供高精密减速机研发、定制与升级服务，是一家在精密传动领域具备自主创新能力、精密加工能力、定制服务及快速反应能力的高科技企业。公司秉承“天道酬勤，业道酬精”的企业精神，为顾客提供优质、快捷、专业的精密减速机产品和服务，引领国内减速机行业发展。",
        video:"https://atomrobot.oss-cn-hangzhou.aliyuncs.com/video/mvb/zhitong.mp4",
        poster:"/static/brand/zhitong/aboutus/video.png",
        aboutTitle:"/static/brand/zhitong/aboutus/top.png",
        aboutTitleWidth:"355px"
  },
  
  metaInfo:{
    title:"智同科技_Movibot品牌_减速机_RV减速机",
    keywords:"RV减速机_精密传动与运动控制_工业机器人_智同科技",
    description:"智同科技是工业机器人用高精密摆线减速机服务商，MOVIBOT为您提供该品牌及产品介绍，丰富的产品选型，让您更快速准确的找到所需商品。",
  }
  


}
export default {
  brandInfoAll
};


// WEBPACK FOOTER //
// ./src/data/brand/2.js